import { render, staticRenderFns } from "./OwnersBookings.vue?vue&type=template&id=4a82ebcd&scoped=true&"
import script from "./OwnersBookings.vue?vue&type=script&lang=js&"
export * from "./OwnersBookings.vue?vue&type=script&lang=js&"
import style0 from "./OwnersBookings.vue?vue&type=style&index=0&id=4a82ebcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a82ebcd",
  null
  
)

export default component.exports